import './contact-treatment.component.ajscss';

import { IEpticaExctractAttachment } from '@commons/history/history-mail/models/eptica-extract';
import { ITimelineEntry, ITimelineTreatmentEntry, TimelineEntry } from '@commons/history/timeline//models/timeline-entry';
import { IContactEntry } from '@commons/models/contact-entry';
import { RESPONSE_AUTO_NAME } from '@history/core/history-deprecated.service';
import { IChangesObject, IComponentController, IComponentOptions, isDefined } from 'angular';
import { i18n } from 'i18next';

import { Direction, InteractionType, MediaType, MomentService, Option } from '@contact/upgrade';

import templateUrl from './contact-treatment.component.ajs.html';

class ContactTreatmentCtrl implements IComponentController {
  private static readonly SUBJECT: string = 'subject';
  /**
   * @see net.awl.od.cng.business.middle.repository.biz.manager.impl.MailAbsenceManageServiceImpl
   **/
  private static readonly ABS_MESSAGE_CONTACT_CONNECTION_PREFIX: string = 'ABS_MSG_FOR_';

  // params
  elementSelectedFn: Function;

  // radiobutton
  selected_type: string = '';
  nb_linked: number = 0;

  internalTimeline: {
    interaction: ITimelineTreatmentEntry;
    allAttachment: IEpticaExctractAttachment[];
  }[];

  constructor(private readonly $uibModal: any, private readonly timeUtil: MomentService, private readonly $i18next: i18n) {}

  $onChanges(onChangesObj: { [property: string]: IChangesObject }): void {
    if (onChangesObj['list']) {
      this.mapTimes(onChangesObj['list'].currentValue);
    }
  }

  select(timeline: ITimelineTreatmentEntry) {
    if (isDefined(timeline.mailComment)) {
      this.$uibModal.open({
        component: 'mailEventPopin',
        keyboard: false,
        ariaLabelledBy: 'modal-header',
        ariaDescribedBy: 'modal-body',
        resolve: {
          event: () => timeline.mailComment,
        },
      });
    } else if (timeline.contactEntry && timeline.contactEntry.interactionType === InteractionType.FAKE_MAIL_ENTRY) {
      return;
    } else if (timeline.contactEntry && timeline.contactEntry.canalName === MediaType.MAIL && !timeline.contactEntry.epticaRequestId) {
      return;
    } else {
      this.elementSelectedFn({ element: timeline });
    }
  }

  // for css cursor
  getPointer(interaction: ITimelineTreatmentEntry): boolean {
    return isDefined(interaction) && isDefined(interaction.mailComment);
  }

  getSubject(interaction: IContactEntry): string {
    let subject: string = '';
    if (
      interaction.canalName === MediaType.MAIL &&
      interaction.canalDirection === Direction.OUTGOING &&
      interaction.interactionType === InteractionType.SECONDARY &&
      !!interaction.connectionId &&
      interaction.connectionId.startsWith(ContactTreatmentCtrl.ABS_MESSAGE_CONTACT_CONNECTION_PREFIX)
    ) {
      subject = this.$i18next.t('history:viewInteractions.ABSENCE_MESSAGE');
      subject += ' ' + interaction.csrFirstname + ' ' + interaction.csrLastname;
    }
    if (subject === '') {
      interaction.contents
        .filter(_content => _content.contentType === MediaType.MAIL)
        .forEach(_content => {
          if (isDefined(_content.content) && _content.content !== '' && _content.content != null) {
            JSON.parse(_content.content)
              .filter(myRow => myRow.key === ContactTreatmentCtrl.SUBJECT)
              .map(myRow => {
                subject = myRow.value;
              });
          }
        });
    }
    if (subject === '') {
      if (interaction.description && interaction.description.indexOf(RESPONSE_AUTO_NAME) !== -1) {
        subject = this.$i18next.t('history:viewInteractions.RESPONSE_AUTO');
      } else {
        subject = interaction.description;
      }
    }
    return subject.replace('Ask for help', this.$i18next.t('agent:contact.mailactions.requestAssist'));
  }

  getDate(interaction: IContactEntry): string {
    if (isDefined(interaction.entryDate)) {
      return this.timeUtil.readableDateTimeNoSep(interaction.entryDate);
    }
    return '';
  }

  private mapTimes(times: ITimelineEntry[]) {
    if (times) {
      this.internalTimeline = times.map((data: ITimelineEntry) => ({
        interaction: this.handleTreatment(TimelineEntry.toTreatment(data)),
        allAttachment: this.allAttachment(data),
      }));
      this.nb_linked = this.internalTimeline.filter(
        data => data.interaction.contactEntry && data.interaction.contactEntry.interactionType === 'LINKED'
      ).length;
    }
  }

  private allAttachment(data: ITimelineEntry): IEpticaExctractAttachment[] {
    if (!data || !data.mailComment) return [];
    return data.mailComment.attachment.concat(
      Option.of(data.mailComment.response)
        .map(r => r.attachment)
        .getOrElse([])
    );
  }

  private handleTreatment(interaction: ITimelineTreatmentEntry) {
    if (interaction.type === 'SECONDARY' && (!interaction.csrFirstName || !interaction.csrLastName)) {
      const unknownUser = this.$i18next.t('commons:basic.user_unknown');
      const [firstNameTranslation, lastNameTranslation] = unknownUser.split(' ');
      interaction.csrFirstName = firstNameTranslation;
      interaction.csrLastName = lastNameTranslation;
    }
    return interaction;
  }
}

export class ContactTreatment implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    list: '<',
    elementSelectedFn: '&',
  };
  controller = ['$uibModal', 'momentService', '$i18next', ContactTreatmentCtrl];
}

export default 'contactTreatmentView';
